import { render, staticRenderFns } from "./StoreAlertMessagesSettings.vue?vue&type=template&id=69377dfe&"
import script from "./StoreAlertMessagesSettings.vue?vue&type=script&lang=js&"
export * from "./StoreAlertMessagesSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports